import { render, staticRenderFns } from "./PlanCorrection.vue?vue&type=template&id=b9f350f8&scoped=true"
import script from "./PlanCorrection.vue?vue&type=script&lang=ts"
export * from "./PlanCorrection.vue?vue&type=script&lang=ts"
import style0 from "./PlanCorrection.vue?vue&type=style&index=0&id=b9f350f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f350f8",
  null
  
)

export default component.exports